var $thecart = $('#top-cart');

function OnAjax() {
  
  $('.u').unveil(500,function() {
  	$(this).load(function() {
	    this.style.opacity = 1;
	  });
  });
}

$(function() {
    var num_cols = 2,
    container = $('.split-list'),
    listItem = 'li',
    listClass = 'sub-list';
    container.each(function(i,v) {
        var items_per_col = new Array(),
        items = $(this).find(listItem),
        min_items_per_col = Math.floor(items.length / num_cols),
        difference = items.length - (min_items_per_col * num_cols);
        for (var i = 0; i < num_cols; i++) {
            if (i < difference) {
                items_per_col[i] = min_items_per_col + 1;
            } else {
                items_per_col[i] = min_items_per_col;
            }
        }
        for (var i = 0; i < num_cols; i++) {
            $(this).append($('<ul ></ul>').addClass(listClass));
            for (var j = 0; j < items_per_col[i]; j++) {
                var pointer = 0;
                for (var k = 0; k < i; k++) {
                    pointer += items_per_col[k];
                }
                $(this).find('.' + listClass).last().append(items[j + pointer]);
            }
        }
    });
    
    $('#filters').on('click',function(e) {
        e.preventDefault();
        $('#filterlist').slideToggle('fast');
    });
    
    $('#collection-sidebar h3').on('click',function(e) {
        $(this).next().slideToggle();
        $(this).toggleClass('active'); 
    });
    
    $('#input-name').on('submit',function(e) {
        e.preventDefault();
        $.cookie('logo_name',$('#logo-name').val(),{path:'/',expires:365});
        window.location.href = $('#product-url').val();  
    });
    
    var slideshow = $('.owl-slideshow');
    slideshow.owlCarousel({
        items: 1,
        loop: true,
        dots: false,
        nav: true,
        autoplay: true,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 15.7 51.9" enable-background="new 0 0 15.7 51.9" xml:space="preserve"><polyline fill="none" stroke="#333333" stroke-miterlimit="10" points="15.3 51.6 0.6 25.9 15.3 0.2 "/></svg>','<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 15.7 51.9" enable-background="new 0 0 15.7 51.9" xml:space="preserve"><polyline fill="none" stroke="#333333" stroke-miterlimit="10" points="0.4 0.2 15.1 25.9 0.4 51.6 "/></svg>']
    });
        
    $('.owl-carousel').each(function(i,l)  {
        var me      = $(this),
            oItems  = me.data('owl-items'),
            oNav    = me.data('owl-nav'),
            oMargin = me.data('owl-margin'),
            oDots   = me.data('owl-dots'),
            oAutoplay = me.data('owl-autoplay');
            
        me.owlCarousel({
            loop: true,
            items: oItems,
            rewindNav: false,
            nav: oNav,
            margin: oMargin,
            navText: ['<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 15.7 51.9" enable-background="new 0 0 15.7 51.9" xml:space="preserve"><polyline fill="none" stroke="#333333" stroke-miterlimit="10" points="15.3 51.6 0.6 25.9 15.3 0.2 "/></svg>','<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 15.7 51.9" enable-background="new 0 0 15.7 51.9" xml:space="preserve"><polyline fill="none" stroke="#333333" stroke-miterlimit="10" points="0.4 0.2 15.1 25.9 0.4 51.6 "/></svg>'],
            dots: oDots,
            autoplay: oAutoplay,
            responsive: {
                0: {items:1},
                600: {items:2},
                980: {items:oItems}
            }
        }); 
    });
    
    $('#top-search-link').on('click',function(e) {
        e.preventDefault();
        $('#top-search-form').fadeToggle('fast');
        $('#top-search-form input[type=text]').focus();
    });

    /*
    $('#two-per-row').on('click',function(e) {
        e.preventDefault();
        $('.product').each(function(i,l) {
            var p = $(this);
            p.removeClass('three-per-row').addClass('two-per-row');
        });
        $.cookie('twoOrThree','two', { expires: 7, path: '/' });
    });
    
    $('#three-per-row').on('click',function(e) {
        e.preventDefault();
        $('.product').each(function(i,l) {
            var p = $(this);
            p.removeClass('two-per-row').addClass('three-per-row');
        });
        $.cookie('twoOrThree','three', { expires: 7, path: '/' });
    });
    */
    
    
    
    
    /*$('#menu-designers').hover(function() {
        $('#designer-dropdown').show();
        $('#main-nav .nav > li:not(#menu-designers)').hover(function() {
            $('#designer-dropdown').hide();
        });
    },function() {
        $('#designer-dropdown').hover(function() {
        },function() {
            $('#designer-dropdown').hide();
        });
    });*/
    
    
    /*$('#main-nav .has-dropdown').hover(function() {
        var me = $(this);
        $(this).find('.sub-nav').show();
        $(this).siblings().hover(function() {
            me.find('.sub-nav').hide();
        });
    },function() {
        $(this).find('.sub-nav').hover(function() {
        },function() {
            $(this).hide();
        });
    });*/
    /*$('#menu-designers').on('click',function(e) {
        e.preventDefault();
        return false;  
    });*/
    
    
    $('.clear-filter').on('click',function(e) {
       e.preventDefault();
       var me = $(this);
       window.location.href = $(this).parent().next().find('li.all a').attr('href');
    });
    
    $('.side-filter').each(function(e,l) {
        if($(this).find('.active').length != 0) {
            $(this).find('.clear-filter').show();
        }
    });
    
    /*$('.product-image-wrap').hover(function() {
       $(this).find('.hover-image').fadeIn(); 
    },function() {
        $(this).find('.hover-image').fadeOut(); 
    });
    */
    
    
	// Show a random slide instead of all of them
	//var randomslide = Math.floor(Math.random()*$('#mainslider li').length)+1;
	//$('#mainslider li:not(:nth-child('+randomslide+'))').remove();
	
	OnAjax();

  
  $('.side-has-sub > a').click(function(e) {
  	if($(this).parent().parent().hasClass('sub-sub-side-menu') || $(this).parent().hasClass('tolink')) {
		
  	} else {
	  	e.preventDefault();  	
  	}
  	$(this).siblings('.sub-side-menu').slideToggle();
  	$(this).parent().toggleClass('open');
  });
  
  

  $('.mfp-inline').magnificPopup({
    type: 'inline',
    midClick: true
  });
  
  $('#qty-minus').on('click',function(e) {
    console.log('minus');
     e.preventDefault(); 
     var val = parseInt($('#quantity').val());
     var newval = val-1;
     if($('#quantity').val() > 1) {
         $('#quantity').val(newval); 
     }
  });
  $('#qty-plus').on('click',function(e) {
     e.preventDefault(); 
     var max = $('#quantity').data('max');
     var val = parseInt($('#quantity').val());
     var newval = val+1;
     if(val < max) {
         $('#quantity').val(newval);
     }
  });
  
  $('.pin-it').click(function(event) {
		var imageSRC = $('#the-current-image').attr('src');
		//if($(this).hasClass('pin-it'))
			//link = $(this).data('link');
		//var image = $(this).data('image');
		//var image = $(this).data('image');
		
		var productURL = $(this).data('url');
		var productDescription = $(this).data('description');
		
		var link = "//pinterest.com/pin/create/button/?url="+productURL+"&description="+productDescription+"&media="+imageSRC+"";
		var width  = 575,
		    height = 400,
		    left   = ($(window).width()  - width)  / 2,
		    top    = ($(window).height() - height) / 2,
		    url    = link,
		    opts   = 'status=1' +
		             ',width='  + width  +
		             ',height=' + height +
		             ',top='    + top    +
		             ',left='   + left;
		
		window.open(url, 'twitter', opts);
		
		return false;
	});	
  
  
  $('.back-to-top').click(function(event) {
		event.preventDefault();
		$('html, body').animate({scrollTop: 0}, 500);
		return false;
  });
  
  	$('#nav-toggle').click(function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('body').toggleClass('menuopen');
		/*$('#side-menu').animate({
			width: 250
		}, 250);*/
		$('#body-cover').fadeToggle();
	});
	/*$('#mobile-cart').on('click',function(e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('body').toggleClass('cartopen');		
        $('#side-cart').animate({
			width: 250
		}, 250).show();
		$('#body-cover').fadeToggle();
     
    });*/
	$('#body-cover').click(function(e) {
		e.preventDefault();
		$('#nav-toggle').removeClass('active');
		/*$('body').animate({
			left: 0
		}, 250,function() {*/
			$(this).removeClass('menuopen');
			$(this).removeClass('cartopen');
			$('#body-cover').fadeOut();
		/*});
		$('#side-menu,#side-cart').animate({
			width: 0
		}, 250);
		*/
		
	});
  
  $('.fitvids').fitVids();
  
 /* $('#customers a.search-icon').click(function(e) {
	  e.preventDefault();
	  $('#top-search').fadeIn();
	  return false;
  });*/
  $('.big-dropdown').hide();

  $('html').removeClass('no-js');
  
  $('.accordion .tab-content').hide();
  $('.accordion h3:first-child').addClass('active');
  //$('.accordion h3.active').next().show().addClass('active');
  $('.accordion .tab-content:eq(0)').show().addClass('active');
  
  $('.accordion > h3').unbind('click').on('click', function(e) {
  	var me = $(this);
  	//console.log(me.text());
  	if(me.next().is(':visible')) {
  		me.removeClass('active').next().removeClass('active').slideUp('fast');
  	} else {
	  	me.addClass('active').next().removeClass('active').slideDown('fast');
  	}
  	return false;
  });
  
  $('.tabs .tab-content').hide();
  $('.tabs-header li:first-child').addClass('active');
  $('.tabs .tab-content:eq(0)').show().addClass('active');
  $('.tabs-header li.tab a').on('click',function(e) {
     e.preventDefault();
     $('.tabs-header li').removeClass('active');
     $(this).parent().addClass('active');
     $('.tabs .tab-content').hide();   
     var tab = $($(this).attr('href'));
     tab.fadeIn();    
  });
  
  
  $('#trends-archive .tab-content').hide();
  $('.trend-archive > h3').on('click',function(e) {
     e.preventDefault();
     var me = $(this);
     if(me.next().is(':visible')) {
  		me.removeClass('active').next().removeClass('active').slideUp('fast');
  	} else {
	  	me.addClass('active').next().removeClass('active').slideDown('fast');
  	}
  	return false;
      
  });
  $('.trend-archive .open').parent().prev().trigger('click');
   
  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  $('.num').click(function(e) {
  	e.preventDefault();
  	var val = $('#quantity').val();
  	var max = $('#quantity').data('max');
  	if($(this).attr('id')=="num-plus") {
  	    if(val < max) { 
    	  	if(val < 9) {
    		  	val++;
    	  	} else {
    		  	val = 9;
    	  	}
	  	} else {
    	  	$('#low-stock').fadeIn();
	  	}
  	} else {
  		if(val >1 ) {
	  		val--;
  		} else {
	  		val=1
  		}
  	}
  	$('#quantity').val(val);
  });


	$('#add').unbind('click').bind('click', fastadd	);
	$('.cartremove').bind('click',fastremove);
	
	$('#article-sidebar-inner').width($('#article-sidebar').width());
	/*$(".sticky").sticky({
		topSpacing: 78,
		zIndex:2,
		stopper: "#end-of-page"
	});*/
	
	/*$(window).on('scroll', function() {
	    var y_scroll_pos = window.pageYOffset;
	    var scroll_pos_test = 140;             // set to whatever you want it to be
	
	    if(y_scroll_pos > scroll_pos_test) {
		    $('#header').addClass('collapse');
		    $('.back-to-top').fadeIn();
	    } else {
		    $('#header').removeClass('collapse');
		    $('.back-to-top').fadeOut();
	    }
	});*/
	
	$('#scroll-to-top').click(function(){
		$('html, body').animate({scrollTop : 0},800);
		return false;
	});
	

  
  	$('.www-filters a').on('click',function(e) {
      	e.preventDefault();
      	var f = $(this).attr('href');
      	$('.www-filters a').removeClass('active');
      	$(this).addClass('active');
      	if(f == '#all') {
          	$('.product').fadeIn();
      	} else {
      		$('.product').hide();
			$('.product[data-type="'+f+'"]').fadeIn();
      	}
  	});
  	
  	$('#top-newsletter-link').magnificPopup({
        items: {
            src: '#newsletter-popup',
            type: 'inline'    
        },
        mainClass: 'mfp-fade',
        removalDelay: 300
      	
  	});
  	
  	/* Cookies and Signup Form */
	var vars = [], hash;
    var q = document.URL.split('?')[1];
    if(q != undefined){
        q = q.split('&');
        for(var i = 0; i < q.length; i++){
            hash = q[i].split('=');
            vars.push(hash[1]);
            vars[hash[0]] = hash[1];
        }
    }
    if(vars['cookie'] == 'remove') {
	    Cookies.remove('hide_popup');
    }
  	
  	if(Cookies.get('hide_popup') == undefined) {
      	setTimeout(function() {
            $('#top-newsletter-link').trigger('click');
            
        }, 2000);
        Cookies.set('hide_popup','true',{expires:30, path: ''});
    }
  	
	
	if($(window).width() > 767) {
	var imgTimer;
	$(document).on({
		mouseenter: function () {
			clearInterval(imgTimer);
			var $a = $(this);
			var $pImg = $a.find('> img:visible');
			if($pImg.attr('data-alt2')) {
				var preLoad2 = new Image();
				preLoad2.src = $pImg.attr('data-alt2');
				var preLoad3 = new Image();
				preLoad3.src = $pImg.attr('data-alt3');
				var imgHtml = '<img src="'+$pImg.attr('data-alt2')+'"><img src="'+$pImg.attr('data-alt3')+'"><img src="'+$pImg.attr('data-original')+'">';
				if($a.find('.altImg').length < 1){
					$a.append('<div class="altImg"></div>');
					$a.find('.altImg').html(imgHtml);
				}else{
					if($a.find('.altImg').html() != imgHtml) {
						$a.find('.altImg').html(imgHtml);
					}
				}
				var imgSet = $a.find('.altImg img');
				$a.find('.altImg').css('background-color','transparent');
				$a.find('.altImg').show();
				$a.find('.altImg img:visible').stop(true,true).fadeOut(500);
				imgSet.eq(0).fadeIn(500,function(){
					$a.find('.altImg').css('background-color','#FFFFFF');
				});
				var i = 1;
				imgTimer = setInterval(
					function(){
						i = (i == imgSet.length) ? 0 : i;
						$a.find('.altImg img:visible').stop(true,true).fadeOut(500);
						imgSet.eq(i).stop(true,true).fadeIn(500);
						i++;
					},
				1500);
			}
		},
		mouseleave: function () {
			clearInterval(imgTimer);
			var $a = jQuery(this);
			$a.find('.altImg img').fadeOut(500);
			$a.find('.altImg').fadeOut(500,function(){
				$a.find('.altImg').remove();
			});
		}
	}, "#collection-list .product a.prod-image");
	
	$('.dd-change').hover(function() {
		var myNum = $(this).data('col'),
			myLink = $(this).data('link'),
			myName = $(this).data('name'),
			myImg = $('.dd-feature .dd-images li[data-col='+myNum+']');
			
		$('.dd-images li').css('z-index','1').removeClass('active');	
		myImg.addClass('active').css('z-index','2').stop().fadeIn(200,function() {
			$('.dd-images li').not('.active').stop().hide();
			var parent = $(this).parent().next();
			parent.find('.dd-name').text(myName).attr('href',myLink);
			parent.find('.dd-link').attr('href',myLink);
		});
	});
	} // end if > 767
	
	if($(window).width() < 768) {
		$('#footer h4').click(function(e) {
			e.preventDefault();
			$(this).toggleClass('active').next().slideToggle();
		});
	}
	
	
    
    
    /* AJAX Mailchimp */
    ajaxMailChimpForm($("#mc"), $("#mce-responses"));
    //ajaxMailChimpForm($("#footer-signup"), $("#footer-signup-result"));
    //ajaxMailChimpForm($("#popup-newsletter"), $('#popup-newsletter-result'));
    var ajaxChimpURL = "//faust.us12.list-manage.com/subscribe/post-json?u=566f544fb071aef6a9a854afd&amp;id=b24d85eca3&c=?";
    //faust.us12.list-manage.com/subscribe/post?u=566f544fb071aef6a9a854afd&amp;id=b24d85eca3
   
    function chimpResponse(resp) {
        var me = $(this);
        var message = "";
        if(resp.result==='success') {
            message = "Thank you for signup up!";
        } else {
            console.log(resp);
            var error = resp.msg.split(' - ');
            message = error[1];
        }
        console.log(me);
        me.find('.subscribe-result').text(message);
    }
    // Turn the given MailChimp form into an ajax version of it.
    // If resultElement is given, the subscribe result is set as html to
    // that element.
    function ajaxMailChimpForm($form, $resultElement){
        // Hijack the submission. We'll submit the form manually.
        $form.submit(function(e) {
            e.preventDefault();
            if (!isValidEmail($form)) {
                var error =  "A valid email address must be provided.";
                $resultElement.html(error);
                $resultElement.css("color", "red");
                $resultElement.fadeIn();
            } else {
            	$resultElement.fadeIn();
                $resultElement.css("color", "black");
                $resultElement.html("Subscribing...");
                submitSubscribeForm($form, $resultElement);
            }
        });
    }
    // Validate the email address in the form
    function isValidEmail($form) {
        // If email is empty, show error message.
        // contains just one @
        var email = $form.find("input[type='text']").val();
        if (!email || !email.length) {
            return false;
        } else if (email.indexOf("@") == -1) {
            return false;
        }
        return true;
    }
    
    
    
    
    function submitSubscribeForm($form, $resultElement) {
        $.ajax({
            type: "GET",
            url: ajaxChimpURL,
            data: $form.serialize(),
            cache: false,
            dataType: "json",
            //jsonp: "c", // trigger MailChimp to return a JSONP response
            contentType: "application/json; charset=utf-8",
            error: function(error){
                // According to jquery docs, this is never called for cross-domain JSONP requests
                console.log(error);
            },
            success: function(data){
                console.log(data);
                if (data.statusText != "success") {
                    var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
                    $resultElement.css("color", "red");
                    if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                        message = "You're already subscribed. Thank you.";
                        $resultElement.css("color", "black");
                    }
                    $resultElement.html(message);
                } else {
                    $resultElement.css("color", "black");
                    $resultElement.html("Thank you!<br>You must confirm the subscription in your inbox.");
                }
            }
        });
        /*$.ajax({
          type: "GET", // GET & url for json slightly different
          url: "http://XXXXXXXX.list-manage2.com/subscribe/post-json?c=?",
          data: $this.serialize(),
          dataType    : 'json',
          contentType: "application/json; charset=utf-8",
          error       : function(err) { alert("Could not connect to the registration server."); },
          success     : function(data) {
              if (data.result != "success") {
                  // Something went wrong, parse data.msg string and display message
              } else {
                  // It worked, so hide form and display thank-you message.
              }
          }
      });*/
    }
    
        
    $('.add').on('click',function(e) {
        e.preventDefault();
        var variant = $(this).data('variant-id');
        Shopify.addItem(variant,1,updateCart);
    });
    
    function updateCart() {
        var AJXPage = '/search';
        var $add = $('.add');
        var $returntime = 2000;
        $.ajax({
          	type: 'GET',
          	url: '/cart.js',
          	dataType: 'json',
          	success: function(cartdata){
          	    $('.add').text('added to cart');
				$.get(AJXPage, function(data) {
					$newcart = $(data).find('#top-hat');
					$curcart = $('#top-hat');
					$curcart.html($newcart.html()).promise().done(function() {
					    GotoStep4();
						$('.cartremove').bind('click',fastremove );
						setTimeout(function() {
							$add.removeAttr('disabled');
						}, $returntime);
					});
				});
          	}
      	});
    }
    if($(window).width() < 768) {
        $('#sort-categories h2').on('click',function(e) {
            e.preventDefault();
            $('#other-categories').show();
        });
        $('#current-sort').on('click',function(e) {
            e.preventDefault();
            $('.sort-options').slideToggle();  
        });
        $('.footer-links').on('click',function(e) {
           $(this).find('a').fadeToggle().toggleClass('block'); 
        });
    }
    
    
    
    
});

$(window).load(function() {
    
    $(window).scroll(function() {
        
    if($(window).width() > 768) {
    	var y = $(this).scrollTop();
    	if(y > 80) {
    		$('#header').addClass('collapse');
    	} else {
    		$('#header').removeClass('collapse');
    	}
    } else {
        var y = $(this).scrollTop();
    	if(y > 80) {
    		$('.mobile-promo').fadeOut();
    	} else {
    		$('.mobile-promo').fadeIn();
    	}
    }
	});
});
function fastadd(e){
	e.preventDefault();
  	var form = $(this).parents('form');
	var $addedtext = "Added to Cart";
	var $addtext = $(this).val();
	var $addcolor = $(this).css('color');
	var $returntime = 3000;
	
	var $add = $('#add');
	$add.attr('disabled','disabled').val($addedtext);
	
	var AJXPage = '/search';
  	$.ajax({
    	type: 'POST',
      	url: '/cart/add.js',
		async: false,
      	data: form.serialize(),
      	dataType: 'json',
      	success: function(response){
        	$.ajax({
              	type: 'GET',
              	url: '/cart.js',
              	dataType: 'json',
              	success: function(cartdata){
					$.get(AJXPage, function(data) {
						var $newcart = $(data).find('#top-cart');
						var $curcart = $('#top-cart');
						var $newsidecart = $(data).find('#sc-wrap');
						var $cursidecart = $('#sc-wrap');
						
						$cursidecart.html($newsidecart.html());
						$curcart.html($newcart.html()).promise().done(function() {
						  	$('.cartremove').bind('click',fastremove );
						    //$('#cart-hover').show();	
						    $('#cart-hover').fadeIn();
							setTimeout(function() {
								//$add.hide();
								$add.removeAttr('disabled');
								$add.val($addtext);
								$('#cart-hover').fadeOut();
								/*.on('click',function(e) {
									e.preventDefault();
									window.href = "/checkout";
								});*/
							}, $returntime);
						});
					});
              	}
          	});
      	},
	  	error: function(response) {
		
		}
  	});
}

function fastremove(e) {
	e.preventDefault();
	var AJXPage = '/search';
	removeURL = $(this).attr('href');
    $.post(removeURL,function(data) {
        $.get(AJXPage, function(data){
            var $newcart = $(data).find('#top-cart');
            $('#top-cart').html($newcart.html());
            $('#sc-wrap').html($(data).find('#sc-wrap').html());
            
        });
    });
}


